module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Cadastro de Formulários'
    }
  }), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Cadastro de Formulários")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Formulários',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "listaFormularios"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro de formulários "), (!_vm.loading.tela) ? _c('span', {
    staticClass: "info_discreto"
  }, [_vm._v(_vm._s(_vm.tabelaFormularios.totalRows) + " localizado(s)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'edita-formulario',
          params: {
            id: null
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo formulário ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "keyup": _vm.ajustaPesquisa,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.tabelaFormularios.filter,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.tabelaFormularios.filter = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row box-body"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: 'tabelaDetalhe',
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "hover": "",
      "bordered": _vm.tabelaFormularios.bordered,
      "items": _vm.formularios,
      "fields": _vm.camposFormularios,
      "filter": _vm.tabelaFormularios.filter,
      "filter-function": _vm.filtroPorItem,
      "current-page": _vm.tabelaFormularios.currentPage,
      "per-page": _vm.tabelaFormularios.perPage,
      "sort-by": _vm.tabelaFormularios.sortBy,
      "sort-desc": _vm.tabelaFormularios.sortDesc,
      "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "filtered": _vm.onFiltered,
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tabelaFormularios, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tabelaFormularios, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tabelaFormularios, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tabelaFormularios, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "id",
      fn: function(row) {
        return [_c('span', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.mostrarDetalhes(row)
            }
          }
        }, [_vm._v(_vm._s(row.value))])]
      }
    }, {
      key: "criacao",
      fn: function(row) {
        return [_c('span', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.mostrarDetalhes(row)
            }
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("moment")((_vm._.has(row.item.cadastro, 'inicio') ? row.item.cadastro.inicio : row.item.created_at), "DD/MM/YYYY  HH:mm")) + "\n                      ")])]
      }
    }, {
      key: "nome",
      fn: function(row) {
        return [_c('span', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.mostrarDetalhes(row)
            }
          }
        }, [_vm._v("\n                        " + _vm._s(row.value) + "\n                        "), (row.item.opcoes.vinculo.programas.length > 0) ? _c('span', {
          staticStyle: {
            "font-size": "x-small",
            "color": "var(--cor-atencao)"
          }
        }, [_c('br'), _vm._v(_vm._s(_vm._.join(_vm._.map(row.item.opcoes.vinculo.programas, 'descricao'), ' | ')) + "\n                        ")]) : _vm._e()]), _vm._v(" "), (!_vm._.isEmpty(row.item.link_acesso)) ? _c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              placement: 'top',
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true,
              delay: [500, 0]
            }),
            expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
          }],
          staticClass: "link_acesso",
          attrs: {
            "title": '<h5>Clique para copiar link para uso externo ao SGP</h5>'
          },
          on: {
            "click": function($event) {
              return _vm.copiaUrl(row)
            }
          }
        }, [_c('br'), _vm._v(_vm._s(_vm._.split(row.item.link_acesso, '-')[0]) + "\n                        "), _c('i', {
          staticClass: "fa fa-clone"
        }), _vm._v(" "), (_vm._.has(row.item, 'link_copia')) ? _c('span', {
          class: _vm._.get(row.item, 'link_copia.classe')
        }, [_vm._v(_vm._s(_vm._.get(row.item, 'link_copia.msg')))]) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "tipo",
      fn: function(row) {
        return [_c('span', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.mostrarDetalhes(row)
            }
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._.find(_vm.tipoFormulario, ['codigo', row.value])['descricao']) + "\n                      ")])]
      }
    }, {
      key: "situacao",
      fn: function(row) {
        return [(_vm._.includes(['Inativo', 'Ativo'], row.item.situacao)) ? _c('span', [_c('div', {
          staticClass: "indicadores-cb-inline"
        }, [(_vm._.has(row.item, 'situacao')) ? _c('div', {
          staticClass: "juntos"
        }, [_c('i', {
          class: (row.item.situacao === 'Ativo' ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.alteraConfiguracaoFormulario(row.item, {
                situacao: row.item.situacao === 'Ativo' ? 'Inativo' : 'Ativo'
              })
            }
          }
        }), _vm._v(" "), _c('span', {
          class: row.item.situacao === 'Ativo' ? 'selecionado' : 'Inativo'
        }, [_vm._v(_vm._s(row.item.situacao))])]) : _vm._e(), _vm._v(" "), (_vm._.has(row.item, 'opcoes.bi') && _vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], row.item.tipo)) ? _c('div', {
          staticClass: "juntos"
        }, [_c('i', {
          class: (row.item.opcoes.bi ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.alteraConfiguracaoFormulario(row.item, {
                'opcoes.bi': !row.item.opcoes.bi
              })
            }
          }
        }), _vm._v(" "), _c('span', {
          class: row.item.opcoes.bi ? 'selecionado' : 'Inativo'
        }, [_vm._v("BI")])]) : _vm._e()])]) : _c('span', {
          staticStyle: {
            "color": "var(--cor-atencao)"
          }
        }, [_vm._v("Erro")])]
      }
    }, {
      key: "uso",
      fn: function(row) {
        return [_vm._v("\n                        " + _vm._s(_vm._.has(_vm.detalhamentoFormulario[row.item.id], 'listaProjetosDisponiveis') ?
          (_vm._.filter(_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], []), function(f) {
            return _vm._.includes(['FEITO', 'EM_EXECUCAO'], f.processo.situacao) && f.andamento !== 'Não iniciado'
          })).length :
          row.item.uso) + "\n                    ")]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [((_vm._.has(_vm.detalhamentoFormulario[row.item.id], 'listaProjetosDisponiveis') ?
          (_vm._.filter(_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], []), function(f) {
            return _vm._.includes(['FEITO', 'EM_EXECUCAO'], f.processo.situacao) && f.andamento !== 'Não iniciado'
          })).length :
          row.item.uso) === 0) ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-formulario',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-label": "false"
          }
        }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Ativo', 'Inativo'], row.item.situacao)) ? _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-formulario',
                params: {
                  id: row.item.id,
                  visualizacao: true
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-label": "false"
          }
        }), _vm._v(" Visualizar")]) : _vm._e()]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row detalhamentoFormulario"
        }, [_c('div', {
          staticClass: "col-md-12"
        }, [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.loading.detalhes),
            expression: "loading.detalhes"
          }],
          staticClass: "overlay",
          staticStyle: {
            "position": "absolute",
            "top": "0px",
            "left": "0px",
            "width": "100%",
            "height": "100%",
            "display": "block"
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh fa-spin"
        })]), _vm._v(" "), (true) ? _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12"
        }, [(!_vm._.has(_vm.detalhamentoFormulario[row.item.id], 'listaProjetosDisponiveis')) ? _c('span', [_c('div', {
          staticClass: "box-header"
        }, [_c('i', {
          staticClass: "fa fa-refresh fa-spin"
        }), _vm._v(" Projetos que podem receber este formulário ...")])]) : _c('span', [((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosDisponiveis'], [])).length === 0) ? _c('div', {
          staticClass: "box-header bg-info"
        }, [_vm._v("\n                                Não há projetos disponíveis para enviar este formulário\n                              ")]) : _c('div', {
          staticClass: "row"
        }, [_c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              placement: 'top',
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true,
              delay: [500, 0]
            }),
            expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
          }],
          staticClass: "col-sm-8",
          attrs: {
            "title": '<h5>Se desejar enviar este formulário para um projeto, então selecione o projeto desejado e clique em Enviar</h5>'
          }
        }, [_c('multiselect', {
          attrs: {
            "options": _vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosDisponiveis'], []),
            "multiple": false,
            "close-on-select": true,
            "placeholder": 'Projetos disponíveis para este formulário',
            "custom-label": function (option) {
              return ("" + (option.ds_codigo_projeto_erp + ' - ' + option.ds_nome))
            },
            "selectedLabel": "selecionado",
            "selectLabel": "",
            "deselectLabel": "",
            "track-by": "ds_codigo_projeto_erp",
            "label": "ds_nome",
            "name": "projetos_disponiveis",
            "data-vv-as": "projetos_disponiveis"
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function(props) {
              return [_c('div', [_c('strong', [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v("  " + _vm._s(props.option.ds_nome) + " "), _c('span', {
                staticClass: "text-gray"
              }, [_vm._v(" " + _vm._s(props.option.ds_situacao_erp) + " ")])])]
            }
          }, {
            key: "noResult",
            fn: function(props) {
              return [_vm._v("\n                                      Não encontrei nesta lista de projetos disponíveis\n                                    ")]
            }
          }], null, true),
          model: {
            value: (_vm.projetoSelecionadoEnvioManual[row.item.id]),
            callback: function($$v) {
              _vm.$set(_vm.projetoSelecionadoEnvioManual, row.item.id, $$v)
            },
            expression: "projetoSelecionadoEnvioManual[row.item.id]"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-sm-2"
        }, [(_vm.projetoSelecionadoEnvioManual[row.item.id]) ? _c('span', [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.vincularFormularioAoProjeto(row.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-list-alt",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Enviar")])], 1) : _c('span', {
          staticClass: "info_discreto"
        }, [_vm._v("\n                                    " + _vm._s((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosDisponiveis'], [])).length) + " projeto(s)\n                                  ")])]), _vm._v(" "), ((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], [])).length > 0) ? _c('div', {
          staticClass: "col-sm-2"
        }, [_c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              placement: 'top',
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          attrs: {
            "color": "success",
            "size": "button--size-ss",
            "title": '<h5>Ao clicar será gerado um Excel com todos os <span class=\'realce\'>' + ((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], [])).length) + '</span> formulário(s) preenchido(s) deste modelo</h5>'
          },
          nativeOn: {
            "click": function($event) {
              _vm.exportarExcel(_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], []))
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excel")])], 1) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm._.has(_vm.detalhamentoFormulario[row.item.id], 'listaProjetosVinculadosFormulario')) ? _c('span', [_c('div', {
          staticClass: "box-header"
        }, [_c('i', {
          staticClass: "fa fa-refresh fa-spin"
        }), _vm._v(" Projetos que tem este formulário ...")])]) : _c('span', [((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], [])).length > 0) ? _c('div', {
          staticClass: "row"
        }, [_c('b-container', {
          attrs: {
            "fluid": ""
          }
        }, [_c('b-table', {
          ref: 'DETALHAMENTO-' + row.item.id + '(' + _vm.numeroAtualizacao + ')',
          attrs: {
            "show-empty": "",
            "striped": "",
            "bordered": _vm.tabelaDetalhamento.bordered,
            "items": _vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], []),
            "fields": _vm.camposDetalhamento,
            "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
            "empty-text": "Nenhum registro encontrado",
            "sort-by": _vm.tabelaDetalhamento.sortBy,
            "sort-desc": _vm.tabelaDetalhamento.sortDesc,
            "current-page": _vm.tabelaDetalhamento.currentPage,
            "per-page": _vm.tabelaDetalhamento.perPage,
            "filter": _vm.tabelaDetalhamento.filter
          },
          on: {
            "update:sortBy": function($event) {
              return _vm.$set(_vm.tabelaDetalhamento, "sortBy", $event)
            },
            "update:sort-by": function($event) {
              return _vm.$set(_vm.tabelaDetalhamento, "sortBy", $event)
            },
            "update:sortDesc": function($event) {
              return _vm.$set(_vm.tabelaDetalhamento, "sortDesc", $event)
            },
            "update:sort-desc": function($event) {
              return _vm.$set(_vm.tabelaDetalhamento, "sortDesc", $event)
            }
          },
          scopedSlots: _vm._u([{
            key: "processo",
            fn: function(row) {
              return [_vm._v("\n                                  " + _vm._s(row.item.processo.id) + "\n                                ")]
            }
          }, {
            key: "projeto",
            fn: function(row) {
              return [(_vm._.has(row.item, 'projeto')) ? _c('span', [_vm._v("\n                                    " + _vm._s(row.item.projeto['ds_codigo_projeto_erp'] + ' - ' + row.item.projeto['ds_nome']) + " ( " + _vm._s(row.item.projeto.ds_situacao_erp) + " )\n                                    "), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', [_c('span', {
                directives: [{
                  name: "tippy",
                  rawName: "v-tippy",
                  value: ({
                    inertia: true,
                    arrow: true,
                    placement: 'top',
                    animation: 'perspective',
                    distance: '1',
                    size: 'large',
                    arrow: true,
                    delay: [500, 0]
                  }),
                  expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
                }],
                staticClass: "link_acesso",
                attrs: {
                  "title": '<h5>Clique para copiar link do formulário para preenchido</h5>'
                },
                on: {
                  "click": function($event) {
                    return _vm.copiaUrl(row)
                  }
                }
              }, [_vm._v("\n                                      " + _vm._s(row.item['link_externo']) + "\n                                      "), _c('i', {
                staticClass: "fa fa-clone"
              }), _vm._v(" "), (_vm._.has(row.item, 'link_copia')) ? _c('span', {
                class: _vm._.get(row.item, 'link_copia.classe')
              }, [_vm._v(_vm._s(_vm._.get(row.item, 'link_copia.msg')))]) : _vm._e()])])]
            }
          }, {
            key: "situacao",
            fn: function(row) {
              return [(row.item.processo.situacao === 'CANCELADO') ? _c('span', {
                staticClass: "text-danger"
              }, [_vm._v("Cancelado")]) : (row.item.processo.situacao === 'FEITO') ? _c('span', {
                staticClass: "text-success"
              }, [_vm._v("Concluído")]) : (row.item.processo.situacao === 'EM_EXECUCAO') ? _c('span', {
                staticClass: "text-blue"
              }, [_vm._v("Em Execução")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
                class: row.item.andamento === 'Não iniciado' ? 'text-gray' : 'text-bold'
              }, [_vm._v("\n                                    " + _vm._s(row.item.andamento) + "\n                                  ")])]
            }
          }, {
            key: "actions",
            fn: function(row) {
              return [(_vm._.get(row.item, '_rowVariant', '') === 'form-salvando') ? _c('span', [_vm._v("Salvando...")]) : (_vm._.get(row.item, '_rowVariant', '') === 'form-fechando') ? _c('span', [_vm._v("Fechando...")]) : _c('span', [(!_vm._.get(row.item, '_rowVariant')) ? _c('span', [(row.item.processo.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
                attrs: {
                  "color": "primary",
                  "type": "button"
                },
                nativeOn: {
                  "click": function($event) {
                    return _vm.abreFormulario(row.item['link_edicao'])
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" Preencher")]) : _vm._e()], 1) : _c('span', [_vm._v("Em uso agora!")]), _vm._v(" "), _c('g-button-ujarak', {
                attrs: {
                  "color": "success",
                  "type": "button"
                },
                nativeOn: {
                  "click": function($event) {
                    return _vm.abreFormulario(row.item['link_visualizacao'])
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-search",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" Visualizar")]), _vm._v(" "), (row.item.processo.situacao !== 'CANCELADO') ? _c('g-button-ujarak', {
                directives: [{
                  name: "confirm",
                  rawName: "v-confirm",
                  value: ({
                    ok: function (retorno) { return _vm.cancelaProcessoPreenchimento(row); },
                    cancel: _vm.doNothing,
                    message: '<span class=\'avisoAlerta\'>Deseja <b>Cancelar</b> este preenchimento?</span>'
                  }),
                  expression: "{ok: retorno => cancelaProcessoPreenchimento(row), cancel: doNothing, message: '<span class=\\'avisoAlerta\\'>Deseja <b>Cancelar</b> este preenchimento?</span>'}"
                }, {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: ({
                    inertia: true,
                    arrow: true,
                    placement: 'top',
                    animation: 'perspective',
                    distance: '1',
                    size: 'large',
                    arrow: true
                  }),
                  expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true}"
                }],
                attrs: {
                  "color": "error",
                  "type": "button",
                  "title": '<h5>Utilize essa opção para cancelar a vinculação</h5>'
                }
              }, [_c('i', {
                staticClass: "fa fa-ban",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" Cancelar")]) : _vm._e()], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('b-row', {
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          }
        }, [_c('b-col', {
          staticClass: "my-1",
          attrs: {
            "md": "6",
            "right": ""
          }
        }, [_c('b-pagination', {
          staticClass: "my-3",
          attrs: {
            "total-rows": _vm.tabelaDetalhamento.totalRows,
            "per-page": _vm.tabelaDetalhamento.perPage
          },
          model: {
            value: (_vm.tabelaDetalhamento.currentPage),
            callback: function($$v) {
              _vm.$set(_vm.tabelaDetalhamento, "currentPage", $$v)
            },
            expression: "tabelaDetalhamento.currentPage"
          }
        })], 1), _vm._v(" "), _c('b-col', {
          attrs: {
            "md": "6",
            "right": ""
          }
        }, [_c('strong', [_vm._v(_vm._s((_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], [])).length))]), _vm._v(" formulário(s) disponibilizado(s) sendo: "), _c('br'), _vm._v(" "), _vm._l((_vm._.groupBy(_vm._.get(_vm.detalhamentoFormulario, [row.item.id, 'listaProjetosVinculadosFormulario'], []), 'processo.situacao')), function(forms, situacao) {
          return _c('span', [(situacao === 'CANCELADO') ? _c('span', {
            staticClass: "text-danger"
          }, [_c('strong', [_vm._v(_vm._s(forms.length))]), _vm._v(" cancelado(s)  ")]) : _vm._e(), _vm._v(" "), (situacao === 'FEITO') ? _c('span', {
            staticClass: "text-success"
          }, [_c('strong', [_vm._v(_vm._s(forms.length))]), _vm._v(" concluído(s)  ")]) : _vm._e(), _vm._v(" "), (situacao === 'EM_EXECUCAO') ? _c('span', {
            staticClass: "text-blue"
          }, [_c('strong', [_vm._v(_vm._s(forms.length))]), _vm._v(" em execução(s)  ")]) : _vm._e()])
        })], 2)], 1)], 1)], 1) : _c('div', [_vm._v("\n                            Não há prenchimento para este formulário\n                          ")])])])])]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.tabelaFormularios.totalRows,
      "per-page": _vm.tabelaFormularios.perPage
    },
    model: {
      value: (_vm.tabelaFormularios.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tabelaFormularios, "currentPage", $$v)
      },
      expression: "tabelaFormularios.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-473b8476!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/avaliacao/CadastroFormulario.vue
// module id = 1880
// module chunks = 2